/* ─────────── Adicionar vários itens de uma vez ───────────
   Um botão, várias variantes: é o que o sistema de dois passos pede, porque
   Step 1 e Step 2 não se compram separados. O /cart/add.js aceita uma lista de
   itens numa só chamada, então não há meia-compra — ou entram os dois, ou
   nenhum.

   Mora fora do lp-hit.js de propósito: aquele arquivo é a LP do Hit, e este
   comportamento é da página de linha e da PDP. O handler é delegado no
   document, então serve section que entre depois (o editor de tema recarrega
   só a section, sem rodar script de novo).

   Contrato: [data-lof-add-multi] com data-variantes="id,id,...".
   Ao terminar, abre a gaveta do carrinho; sem gaveta, vai para /cart. */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lof-add-multi]');
    if (!btn || btn.disabled) return;

    var ids = (btn.getAttribute('data-variantes') || '')
      .split(',')
      .map(function (s) { return Number(s.trim()); })
      .filter(function (n) { return n > 0; });
    if (!ids.length) return;

    var rotulo = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adicionando…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: ids.map(function (id) { return { id: id, quantity: 1 }; })
      })
    })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () {
        var t = document.querySelector('[data-cart-toggle]');
        if (t) { t.click(); } else { window.location.href = '/cart'; }
      })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () { btn.disabled = false; btn.textContent = rotulo; });
  });
})();